import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { newDossierValue } from '../redux/actions/devisActions';
import { fetchCissct, changeIndexValue } from '../redux/actions/cissctActions';
import '../Styles/CISSCT/NumDossCISSCT.scss';

const NumDossCISSCT = () => {
  const dispatch = useDispatch();

  const dossierList = useSelector(state => state.dossier.items);
  const cissctList = useSelector(state => state.cissct.items);
  const selectedDossier = useSelector(state => state.devis.dossierValue);
  const selectedIndex = useSelector(state => state.cissct.index);

  useEffect(() => {
    if (selectedDossier) {
      dispatch(fetchCissct(selectedDossier));
    }
  }, [selectedDossier, dispatch]);

  useEffect(() => {
    if (cissctList.length === 0 || selectedDossier === '') {
      if (selectedIndex !== '') {
        dispatch(changeIndexValue(''));
      }
      return;
    }

    const maxCissctIndex = Math.max(...cissctList.map(item => item.cissct_index));
    const isCurrentIndexValid = cissctList.some(
      ({ cissct_index }) => cissct_index === selectedIndex
    );

    if (selectedIndex === '' || !isCurrentIndexValid) {
      dispatch(changeIndexValue(maxCissctIndex));
    }
  }, [cissctList, selectedDossier, dispatch]);

  const onDossierChange = useCallback(
    e => {
      dispatch(changeIndexValue(''));
      dispatch(newDossierValue(e.target.value));
    },
    [dispatch]
  );

  const onIndexChange = useCallback(
    e => dispatch(changeIndexValue(+e.target.value)),
    [dispatch]
  );

  return (
    <div className="cissct-menu">
      <div className="dossiers">
        <label htmlFor="dossier">N° Dossier : </label>
        <select
          id="dossier"
          value={selectedDossier}
          onChange={onDossierChange}
        >
          {dossierList.map(({ ndossier }) => (
            <option key={ndossier} value={ndossier}>
              {ndossier}
            </option>
          ))}
        </select>
      </div>

      <div className="indice">
        <label htmlFor="index">Convocation : </label>
        <select
          id="index"
          value={selectedIndex}
          onChange={onIndexChange}
          disabled={cissctList.length === 0}
        >
          {cissctList.length === 0 ? (
            <option value="">Aucune convocation</option>
          ) : (
            cissctList.map(({ cissct_index }) => (
              <option key={cissct_index} value={cissct_index}>
                {cissct_index}
              </option>
            ))
          )}
        </select>
      </div>
    </div>
  );
};

export default NumDossCISSCT;
